import ProposalEdit from 'assets/icons/fa/edit-proposal.svg'

ProposalEdit.displayName = 'ProposalEdit'
export default ProposalEdit
